__turbopack_context__.v({
  "active": "SearchCategories-module-scss-module__bv1qaq__active",
  "aiBadge": "SearchCategories-module-scss-module__bv1qaq__aiBadge",
  "categoryBadge": "SearchCategories-module-scss-module__bv1qaq__categoryBadge",
  "divider": "SearchCategories-module-scss-module__bv1qaq__divider",
  "root": "SearchCategories-module-scss-module__bv1qaq__root",
});
